/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminCreatePalletOrderRequest
 */
export interface AdminCreatePalletOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePalletOrderRequest
     */
    items: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePalletOrderRequest
     */
    junkItems?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCreatePalletOrderRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreatePalletOrderRequest
     */
    orderDate: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreatePalletOrderRequest
     */
    orderLink: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePalletOrderRequest
     */
    price: number;
}

export function AdminCreatePalletOrderRequestFromJSON(json: any): AdminCreatePalletOrderRequest {
    return AdminCreatePalletOrderRequestFromJSONTyped(json, false);
}

export function AdminCreatePalletOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCreatePalletOrderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': json['items'],
        'junkItems': !exists(json, 'junkItems') ? undefined : json['junkItems'],
        'name': json['name'],
        'orderDate': json['orderDate'],
        'orderLink': json['orderLink'],
        'price': json['price'],
    };
}

export function AdminCreatePalletOrderRequestToJSON(value?: AdminCreatePalletOrderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items,
        'junkItems': value.junkItems,
        'name': value.name,
        'orderDate': value.orderDate,
        'orderLink': value.orderLink,
        'price': value.price,
    };
}

